<template>
    <div class="text-center profile-picture tw-flex tw-items-center">
        <div @mouseenter="showLabel = true"
             @mouseleave="showLabel = false"
             @click="showUploader"
             class="picture-container"
             :style="'background-image: url(' + picturePath + '?' + version + ')'"
        >
            <div v-show="showLabel" class="upload-label">
              {{ customStrings.uploadLabel }}
            </div>
        </div>

        <modal name="profile-picture-upload" height="auto">
            <div class="position-relative">

                <loader :visible="loading"></loader>

                <div class="alert alert-danger mt-10 ml-10 mr-10" v-if="errors">
                    <ul>
                        <li v-for="message in errors" v-text="message"></li>
                    </ul>
                </div>

                <div class="mt-10">
                    <picture-input
                            ref="pictureInput"
                            :hideChangeButton="true"
                            width="400"
                            height="400"
                            margin="16"
                            accept="image/jpeg,image/png"
                            size="20"
                            :customStrings="customStrings"
                            @change="pictureChanged">
                    </picture-input>
                </div>

                <div class="display-flex justify-center mt-10 mb-10">
                    <button class="cu-btn" type="button" @click="storeImage">
                        <i class="fa fa-save"></i>
                      {{ customStrings.save }}
                    </button>

                    <button class="cu-btn-default tw-ml-4" type="button" @click="abortUpload">
                        <i class="fa fa-times"></i>
                      {{ customStrings.cancel }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import axios from 'axios';
import Loader from '../Loader';
import PictureInput from 'vue-picture-input';

export default {
      props: {
        userId: {},
        picturePath: {},
        customStrings: {
          type: Object,
          default: () => ({}),
        },
      },

        components: { Loader, PictureInput },

        data() {
            return {
                showLabel: false,
                image: null,
                loading: false,
                errors: null,
                version: Date.now(),
            }
        },

        computed: {

        },

        methods: {
            showUploader() {
                this.$modal.show('profile-picture-upload');
            },

            pictureChanged() {
                let image = this.$refs.pictureInput.file;

                if (! image) {
                    console.error('FileReader API not supported!');
                    return;
                }

                this.image = image;
            },

            storeImage() {
                if (! this.image) {
                  this.errors = [this.customStrings.noValidImage];
                    console.error('No Image selected!');
                    return;
                }

                this.loading = true;
                this.errors = null;

                let formData = new FormData();

                formData.append("photo", this.image, this.image.name);

                axios.post(`/user/${this.userId}/upload`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(() => {
                        this.version = Date.now();
                        this.$modal.hide('profile-picture-upload');
                    })
                    .catch(error => {
                        this.errors = error.response.data;
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },

            abortUpload() {
                this.$modal.hide('profile-picture-upload');
            }
        }
    }
</script>